import { useState, useEffect, useCallback } from 'react';
import { LayoutTemplate, Save } from 'lucide-react';
import { toast } from 'sonner';
import api from '../lib/api';

// Reusable bar for offer dialogs: insert a saved template or save the current
// line items + note as a new template.
export default function OfferTemplateBar({ items, note, onApply }) {
  const [templates, setTemplates] = useState([]);

  const load = useCallback(() => {
    api.get('/offer-templates').then((r) => setTemplates(r.data?.templates || [])).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);

  const apply = (id) => {
    const t = templates.find((x) => x.id === id);
    if (!t) return;
    onApply(
      (t.items || []).map((i) => ({ description: i.description || '', quantity: i.quantity ?? 1, unit_price: i.unit_price ?? '' })),
      t.note || '',
    );
    toast.success(`Vorlage „${t.title}" eingefügt`);
  };

  const saveAsTemplate = async () => {
    const clean = (items || []).filter((i) => (i.description || '').trim());
    if (!clean.length) { toast.error('Keine Positionen zum Speichern.'); return; }
    const title = window.prompt('Titel der Vorlage:');
    if (!title || !title.trim()) return;
    try {
      await api.post('/offer-templates', {
        title: title.trim(),
        items: clean.map((i) => ({ description: i.description.trim(), quantity: Number(i.quantity) || 0, unit_price: Number(i.unit_price) || 0 })),
        note: note || '',
      });
      toast.success('Als Vorlage gespeichert');
      load();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Fehler');
    }
  };

  return (
    <div className="flex items-center gap-2 flex-wrap p-2 rounded-lg bg-[#F9F9F7] border border-[#E5E5E0]" data-testid="offer-template-bar">
      <LayoutTemplate className="w-4 h-4 text-[#5C5C59]" />
      <select
        onChange={(e) => { if (e.target.value) { apply(e.target.value); e.target.value = ''; } }}
        data-testid="template-select"
        className="flex-1 min-w-[160px] text-sm border border-[#E5E5E0] rounded px-2 py-1.5 bg-white focus:outline-none"
        defaultValue=""
      >
        <option value="">Vorlage einfügen…</option>
        {templates.map((t) => (
          <option key={t.id} value={t.id}>{t.title}</option>
        ))}
      </select>
      <button
        type="button"
        onClick={saveAsTemplate}
        data-testid="template-save-btn"
        className="inline-flex items-center gap-1 text-xs px-3 py-1.5 rounded border border-[#E5E5E0] text-[#1C1C19] hover:bg-white transition"
      >
        <Save className="w-3.5 h-3.5" /> Als Vorlage speichern
      </button>
    </div>
  );
}
